import { Routes } from '@angular/router';
import { provideUserStore } from '@app/store/user';
import { provideAssessorAssignmentsStore } from '@app/store/assessor-assignments';
import { ModalComponent } from '@shared/components';
import { EditComponent } from './edit/edit.component';

export const assessorsModalRoutes: Routes = [
    {
        path: 'assessors/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideUserStore(), ...provideAssessorAssignmentsStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
